(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
const schemata = require('schemata')
const performanceTimesSchema = require('./show-performance-times-schema')
const pricesSchema = require('./show-prices-schema')
const financeSchema = require('./show-finance-schema')
const createTaxSchema = require('./tax-schema')
const validateIfPropertyEquals = require('@clocklimited/validity-validate-if-property-equals')
const required = require('@clocklimited/validity-required')

function requiredIfContractNotCrossCollateralised (key, keyDisplayName, object, contract, callback) {
  if (contract && contract.hasOwnProperty('crossCollateralised') && !contract.crossCollateralised) {
    return required(key, keyDisplayName, object, callback)
  }
  callback(null, undefined)
}

module.exports = function () {
  return schemata(
    { _id:
      { type: String
      // @todo: once schemata can handle defaultValues in nested collections, add defaultValue here and remove it from
      // the service
      }
    , venue:
      { type: String
      , validators:
       { all: [ required ]
       }
      }
    , festival:
      { type: String
      , validators:
       { all: [ validateIfPropertyEquals('type', 'Festival', required) ]
       }
      }
    , stage:
      { type: String
      , validators:
       { all: [ validateIfPropertyEquals('type', 'Festival', required) ]
       }
      }
    , event:
      { type: String
      , validators:
       { all: [ validateIfPropertyEquals('type', 'Festival', required) ]
       }
      }
    , description:
      { type: String
      }
    , name:
      { type: String
      }
    , capacity:
      { type: String // it’s often “TBC” etc. so cannot be a number
      }
    , billing:
      { type: String
      }
    , otherActs:
      { type: String
      }
    , type:
      { type: String
      }
    , date:
      { type: Date
      , validators:
        { all: [ required ]
        }
      }
    , fee:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , feeCurrency:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , feePercentage:
      { type: String
      }
    , feeNotes:
      { type: String
      }
    , tax:
      { type: createTaxSchema()
      , validators:
        { all: [ requiredIfContractNotCrossCollateralised ]
        }
      , defaultValue: null
      }
    , dealType:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , taxNotes:
      { type: String
      }
    , pricingNotes:
      { type: String
      }
    , localCurrency:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , merchSeller:
      { type: String
      }
    , merchPercentage:
      { type: String
      }
    , merchNotes:
      { type: String
      }
    , performanceTimes:
      { type: schemata.Array(performanceTimesSchema)
      }
    , prices:
      { type: schemata.Array(pricesSchema)
      }
    , dateCreated:
      { type: Date
      , defaultValue: function () { return new Date() }
      }
    , city:
      { type: String
      }
    , finance:
      { type: financeSchema
      }
    , _keywords:
      { type: String
      }
    , hideFromBookingList:
      { type: Boolean
      , defaultValue: false
      }
    , balanceDue:
      { type: Number
      }
    , pencilId:
      { type: String
      , defaultValue: null
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/contract/show-schema.js","/components/service/contract")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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